import commentsPinboardTeaserStore from 'store/comments-pinboard-teaser-store'

export interface ISetValues {
  skus?: string[]
  tags?: string[]
  brands?: string[]
}

/**
 * Command for client to set the pinboard teaser with different filters based
 * on skus, brands, and/or tags.
 * @param resetValues - {skus, brands, tags}
 */
export function set(values: ISetValues): void {
  commentsPinboardTeaserStore.skus = values.skus || []
  commentsPinboardTeaserStore.tags = values.tags || []
  commentsPinboardTeaserStore.brands = values.brands || []
}
